import clsx from "clsx";
import type { SVGAttributes } from "react";

interface SpinnerProps extends Omit<SVGAttributes<SVGSVGElement>, "children"> {
  size?: number | string;
  label?: string;
}

export function Spinner({
  size = 20,
  label,
  className,
  ...rest
}: SpinnerProps) {
  return (
    <svg
      role={label ? "status" : "presentation"}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={clsx("animate-spin", className)}
      {...rest}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeOpacity="0.25"
        strokeWidth="3"
      />
      <path
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Spinner;
